import { t } from "@lingui/macro";
import { i18n } from "@lingui/core";

export default [
  { value: 0, label: i18n._(t`Greenwich Mean Time (UTC)`) },
  { value: -600, label: i18n._(t`Hawaii Time`) },
  // Alaska observes DST
  { value: -540, label: i18n._(t`Alaska Standard Time (AKST)`) },
  { value: -480, label: i18n._(t`Alaska Daylight Time (AKDT)`) },
  // Pacific observes DST
  { value: -480, label: i18n._(t`Pacific Standard Time (PST)`) },
  { value: -420, label: i18n._(t`Pacific Daylight Time (PDT)`) },
  // Mountain observes DST (note: Arizona remains on MST year-round)
  { value: -420, label: i18n._(t`Mountain Standard Time (MST)`) },
  { value: -360, label: i18n._(t`Mountain Daylight Time (MDT)`) },
  // Central observes DST
  { value: -360, label: i18n._(t`Central Standard Time (CST)`) },
  { value: -300, label: i18n._(t`Central Daylight Time (CDT)`) },
  // Eastern observes DST (Ontario/Quebec etc.)
  { value: -300, label: i18n._(t`Eastern Standard Time (EST)`) },
  { value: -240, label: i18n._(t`Eastern Daylight Time (EDT)`) },
  // Atlantic observes DST
  { value: -240, label: i18n._(t`Atlantic Standard Time (AST)`) },
  { value: -180, label: i18n._(t`Atlantic Daylight Time (ADT)`) },
  // Newfoundland observes DST (half-hour offset)
  { value: -210, label: i18n._(t`Newfoundland Standard Time (NST)`) },
  { value: -150, label: i18n._(t`Newfoundland Daylight Time (NDT)`) },
];
